import React, { useEffect, useState } from "react";
import { YearAndPeriod } from "@/models/";
import { Apartment, ApartmentStats, Convert, OwnerAirbnbReview } from "@/models/responses";
import { getPeriodByValue } from "@/utils/periods";
import { useAppData } from "@/hooks/useAppData";
import { fetchOptions, getApiBasePath } from "@/hooks/fetchOptions";
import { apiUrl } from "@/layouts/apiUrl";
import ReportGraphsView from "./reportGraphsView";

interface ReportGraphsProps {
    yearAndPeriod: YearAndPeriod;
    apartments: Apartment[];
    apartmentStats: ApartmentStats[];
    airbnbReviews: OwnerAirbnbReview[];
}

const ReportGraphs: React.FC<ReportGraphsProps> = ({ yearAndPeriod, apartments, apartmentStats, airbnbReviews }) => {
    const [periodBreakdownStats, setPeriodBreakdownStats] = useState<ApartmentStats[][]>([]);
    const [periodNames, setPeriodNames] = useState<string[]>([]);
    const [previousStats, setPreviousStats] = useState<ApartmentStats[]>([]);
    const { selectedOwner } = useAppData();

    useEffect(() => {
        let currentPeriodUrl = `${apiUrl}${getApiBasePath()}/owners/${selectedOwner}/stats?year=${yearAndPeriod.year}&period=${getPeriodByValue(yearAndPeriod.period)}`;
        let previousPeriodUrl = `${apiUrl}${getApiBasePath()}/owners/${selectedOwner}/stats?year=${yearAndPeriod.year - 1}&period=${getPeriodByValue(yearAndPeriod.period)}`;
        fetch(previousPeriodUrl, fetchOptions)
            .then((response) => {
                if (response) {
                    return response.text();
                }
                throw new Error("Unauthorized");
            })
            .then((response) => {
                setPreviousStats(Convert.toGetStatsForApartmentsResponse(response).apartmentStats);
            })
            .catch((error) => console.log(error));
        let periodBreakdownStatsUrl = currentPeriodUrl + "&periodBreakdown=true&foo=bar";
        fetch(periodBreakdownStatsUrl, fetchOptions)
            .then((response) => {
                if (response) {
                    return response.text();
                }
                throw new Error("Unauthorized");
            })
            .then((response) => {
                let periodBreakdownStats = Convert.toGetPeriodBreakdownStatsResponse(response).periodBreakdownStats;
                setPeriodBreakdownStats(periodBreakdownStats.apartmentStats);
                setPeriodNames(periodBreakdownStats.periodNames);
            })
            .catch((error) => console.log(error));
    }, [yearAndPeriod, selectedOwner]);

    return (
        <ReportGraphsView
            yearAndPeriod={yearAndPeriod}
            apartments={apartments}
            apartmentStats={apartmentStats}
            airbnbReviews={airbnbReviews}
            periodBreakdownStats={periodBreakdownStats}
            periodNames={periodNames}
            previousStats={previousStats}
        />
    );
};

export default ReportGraphs;
